import React from "react";
import { CircleDots, LazyLoadImage } from "../../../../../core/atoms";
import classNames from "classnames";
import "./aboutMeetTheTeamHero.scss";

export const AboutMeetTheTeamHero = () => {
  const quoteImage: ISrcSet = {
    default: "https://resources.travellocal.com/tom_and_huw_edit_thumb.jpg",
    srcs: [
      {
        src: "https://resources.travellocal.com/tom_and_huw_edit_thumb.jpg",
        width: 256, // Intrinsic width
      },
    ],
  };

  return (
    <div className="meet-the-team-hero">
      <div className="meet-the-team-hero__inner">
        <div className="meet-the-team-hero__header">
          <h1>Meet the team</h1>
        </div>
        <img className="meet-the-team-hero__image" src="https://www.travellocal.com/images/team.jpg" />
        <blockquote className="meet-the-team-hero__quote">
          &quot;At the core of TravelLocal is its people. Everyone involved is important to us,{` `}
          from our customers to our wonderful team in Bristol and our local partners all over the world.&quot;
          <cite className={classNames("meet-the-team-hero__cite", "text--caps")}>Tom and Huw, Founders</cite>
          <LazyLoadImage src={quoteImage} className="meet-the-team-hero__quote-image" alt="Tom and Huw" />
        </blockquote>
        <CircleDots
          className="meet-the-team-hero__circle-dots"
          centerX="100%"
          centerY="28%"
          radius="20%"
          colour="grey"
          zIndex="behind"
        />
      </div>

    </div>
  );
};
